import { Card, formatPersianNumber } from '../../../app/components/foundation';
import { ControlPlaneDataSurface, ControlPlaneSection } from '../../../app/components/foundation/control-plane';
import type { AnalyticsSnapshot } from '../types/analytics.types';

interface AnalyticsLiveOverviewProps {
  analytics: AnalyticsSnapshot;
}

export function AnalyticsLiveOverview({ analytics }: AnalyticsLiveOverviewProps) {
  return (
    <>
      <ControlPlaneSection>
        <ControlPlaneDataSurface>
          <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
            <section className="vania-analytics-operational-summary">
            <h2 className="mb-3 text-lg font-semibold">کیف پول</h2>
            <p>واریز: {formatPersianNumber(analytics.wallet.deposits)} تومان</p>
            <p>برداشت: {formatPersianNumber(analytics.wallet.withdraws)} تومان</p>
            <p>شارژ: {formatPersianNumber(analytics.wallet.topups)} تومان</p>
            </section>
            <section className="vania-analytics-operational-summary">
            <h2 className="mb-3 text-lg font-semibold">وضعیت سفارش‌ها</h2>
            {analytics.orders.status_distribution.map((item) => <p key={item.status}>{item.status}: {formatPersianNumber(item.count)}</p>)}
            </section>
          </div>
        </ControlPlaneDataSurface>
      </ControlPlaneSection>
      <ControlPlaneSection>
        <ControlPlaneDataSurface>
          <div className="vania-analytics-table-scroll"><table className="vania-analytics-table"><thead><tr><th>بازه</th><th>سفارش‌ها</th><th>درآمد</th></tr></thead><tbody>
            {analytics.time_series.map((item) => <tr key={item.period}><td dir="ltr">{item.period}</td><td>{formatPersianNumber(item.orders)}</td><td>{formatPersianNumber(item.revenue)} تومان</td></tr>)}
          </tbody></table></div>
        </ControlPlaneDataSurface>
      </ControlPlaneSection>
      <ControlPlaneSection title="عملکرد نمایندگان">
        <ControlPlaneDataSurface>
          <div className="vania-analytics-table-scroll"><table className="vania-analytics-table"><thead><tr><th>نماینده</th><th>سفارش‌ها</th><th>درآمد</th><th>کمیسیون</th></tr></thead><tbody>
            {analytics.representatives.map((item) => <tr key={item.representative_id}><td>{item.full_name || item.representative_id}</td><td>{formatPersianNumber(item.orders)}</td><td>{formatPersianNumber(item.revenue)} تومان</td><td>{formatPersianNumber(item.commission)} تومان</td></tr>)}
          </tbody></table></div>
        </ControlPlaneDataSurface>
      </ControlPlaneSection>
    </>
  );
}
